import { ListaClientesPorEjecutivo, Container } from "../../components";

export const ClientesCartera = () => (
  <Container header titulo="Cartera Clientes por Ejecutivo">
    <ListaClientesPorEjecutivo />
  </Container>
);
